var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "通道配置",
        visible: _vm.visible,
        confirmLoading: _vm.loading,
        width: "700px",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-col": { span: 6 },
            "wrapper-col": { span: 18 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c("a-alert", {
                    staticStyle: { "margin-bottom": "24px" },
                    attrs: {
                      message: "通道配置信息",
                      description: `当前配置通道：${_vm.channelData.channelName} (${_vm.channelData.channelId})`,
                      type: "info",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "商户费率", prop: "feeRate" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          max: 100,
                          step: 0.01,
                          precision: 2,
                          placeholder: "请输入费率",
                        },
                        model: {
                          value: _vm.formData.feeRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "feeRate", $$v)
                          },
                          expression: "formData.feeRate",
                        },
                      }),
                      _c(
                        "span",
                        { attrs: { slot: "suffix" }, slot: "suffix" },
                        [_vm._v("%")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "费用计算方式", prop: "feeType" } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.formData.feeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "feeType", $$v)
                            },
                            expression: "formData.feeType",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: 1 } }, [
                            _vm._v("百分比"),
                          ]),
                          _c("a-select-option", { attrs: { value: 2 } }, [
                            _vm._v("固定金额"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "单笔最小", prop: "minAmount" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          step: 0.01,
                          precision: 2,
                          placeholder: "最小金额",
                        },
                        model: {
                          value: _vm.formData.minAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "minAmount", $$v)
                          },
                          expression: "formData.minAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "单笔最大", prop: "maxAmount" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          step: 0.01,
                          precision: 2,
                          placeholder: "最大金额",
                        },
                        model: {
                          value: _vm.formData.maxAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "maxAmount", $$v)
                          },
                          expression: "formData.maxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "日累计限额", prop: "dayMaxAmount" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          step: 0.01,
                          precision: 2,
                          placeholder: "日限额",
                        },
                        model: {
                          value: _vm.formData.dayMaxAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "dayMaxAmount", $$v)
                          },
                          expression: "formData.dayMaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "月累计限额", prop: "monthMaxAmount" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          step: 0.01,
                          precision: 2,
                          placeholder: "月限额",
                        },
                        model: {
                          value: _vm.formData.monthMaxAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "monthMaxAmount", $$v)
                          },
                          expression: "formData.monthMaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "排序权重", prop: "sortOrder" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          max: 999,
                          placeholder: "数值越大越优先",
                        },
                        model: {
                          value: _vm.formData.sortOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sortOrder", $$v)
                          },
                          expression: "formData.sortOrder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "状态", prop: "state" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.formData.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "state", $$v)
                            },
                            expression: "formData.state",
                          },
                        },
                        [
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v("启用"),
                          ]),
                          _c("a-radio", { attrs: { value: 0 } }, [
                            _vm._v("禁用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("a-textarea", {
                        attrs: { rows: 3, placeholder: "请输入备注信息" },
                        model: {
                          value: _vm.formData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "remark", $$v)
                          },
                          expression: "formData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-divider", [_vm._v("扩展配置参数")]),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "配置参数", prop: "configParams" } },
                    [
                      _c("a-textarea", {
                        attrs: {
                          rows: 8,
                          placeholder:
                            '请输入JSON格式的配置参数，如：&#10;{&#10;  "apiKey": "your_api_key",&#10;  "secretKey": "your_secret_key"&#10;}',
                        },
                        model: {
                          value: _vm.configParamsText,
                          callback: function ($$v) {
                            _vm.configParamsText = $$v
                          },
                          expression: "configParamsText",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "config-tips" },
                        [
                          _c("a-icon", { attrs: { type: "info-circle" } }),
                          _c("span", [_vm._v("请输入有效的JSON格式配置参数")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }